import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const PerformanceMetricsChart = () => {
  // Static performance data for display
  const data = [
    { time: '00:00', responseTime: 120, uptime: 100 },
    { time: '04:00', responseTime: 95, uptime: 100 },
    { time: '08:00', responseTime: 145, uptime: 100 },
    { time: '12:00', responseTime: 180, uptime: 99.9 },
    { time: '16:00', responseTime: 160, uptime: 100 },
    { time: '20:00', responseTime: 110, uptime: 100 },
    { time: 'Now', responseTime: 125, uptime: 100 }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <h3 className="text-lg font-semibold text-foreground mb-4">Performance Metrics (24h)</h3>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="time" fontSize={12} />
          <YAxis fontSize={12} />
          <Tooltip />
          <Line type="monotone" dataKey="responseTime" stroke="#3b82f6" strokeWidth={2} name="Response Time (ms)" dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PerformanceMetricsChart;